export default __webpack_public_path__ + "static/media/how-to-use-175.bb87ea83.png";